// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2161":"96dc37e262feb85b","2574":"96dc37e262feb85b","2888":"cc5f94f2f4531a9b","6997":"96dc37e262feb85b"}[chunkId] + ".css";
};